import React from "react";
import { Container, ProgressBar } from "react-bootstrap";
import Card from "../HOME/Card";
import { Rate } from "antd";
import Slider from "react-slick";
import FAQ from "../HOME/FAQ";
import RecentSearch from "../HOME/RecentSearch";

const TabsDesc = () => {
  var settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    initialSlide: 0,
    arrows:true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          initialSlide: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
    <div style={{overflowX:"hidden"}}>
      <section className="py-4">
        <Container>
          <div className="row">
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <div>
                <div className="text-center">
                  <img className="img-fluid devli-ig" src="/assets/pack.png" />
                  <p className="devli-igpara">Free Delivery </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <div>
                <div className="text-center">
                  <img
                    className="img-fluid devli-ig"
                    src="/assets/return.png"
                  />
                  <p className="devli-igpara">Exchange Device </p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <div>
                <div className="text-center">
                  <img className="img-fluid devli-ig" src="/assets/money.png" />
                  <p className="devli-igpara">No Cost EMI</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-3 col-sm-3 col-3">
              <div>
                <div className="text-center">
                  <img
                    className="img-fluid devli-ig"
                    src="/assets/discount.png"
                  />
                  <p className="devli-igpara">Discounts</p>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="py-4">
        <Container>
          <h2 className="head-txt-1 text-start">
            <span>Smart</span> Prize Compare
          </h2>
          <div className="row">
            <div className="sm-hidevs col-lg-3 col-md-4">
            <div className="col-lg-3 col-md-4 col-sm-4 col-4 d-flex justify-content-center align-items-center">
              <div>
                <img className="img-fluid vs" src="/assets/vs.png" />
              </div>
            </div>
            </div>
              {/* <Card /> */}
          </div>
          <div className="pt-3">
            <table className="table-view">
              <tr>
                <th>Prize</th>
                <th>₹ 19,499.00</th>
                <th>₹ 19,499.00</th>
                <th>₹ 19,499.00</th>
              </tr>
              <tr>
                <td>Rating</td>
                <td>
                  <Rate disabled defaultValue={2} className="rate-table"/>
                </td>
                <td>
                  <Rate disabled defaultValue={2} className="rate-table" />
                </td>
                <td>
                  <Rate disabled defaultValue={2} className="rate-table" />
                </td>
              </tr>
              <tr>
                <td>Display size</td>
                <td>16.39 cm</td>
                <td>16.39 cm</td>
                <td>16.39 cm</td>
              </tr>
              <tr>
                <td>Memory capacity </td>
                <td>128 GB</td>
                <td>128 GB</td>
                <td>128 GB</td>
              </tr>
              <tr>
                <td>Model name</td>
                <td>Samsung Galaxy A15 5G</td>
                <td>Samsung Galaxy A15 5G</td>
                <td>Samsung Galaxy A15 5G</td>
              </tr>
              <tr>
                <td>Operating system </td>
                <td>Android 14</td>
                <td>Android 14</td>
                <td>Android 14</td>
              </tr>
              <tr>
                <td>Wireless tech</td>
                <td>Bluetooth, USB, Wi-Fi</td>
                <td>Bluetooth, USB, Wi-Fi</td>
                <td>Bluetooth, USB, Wi-Fi</td>
              </tr>
              <tr>
                <td>Hardware interface </td>
                <td>usb2.0</td>
                <td>usb2.0</td>
                <td>usb2.0</td>
              </tr>
              <tr>
                <td>Display type </td>
                <td>AMOLED</td>
                <td>AMOLED</td>
                <td>AMOLED</td>
              </tr>
              <tr>
                <td>No.of USB port </td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>Input interface </td>
                <td>touch screen stylus pen</td>
                <td>touch screen stylus pen</td>
                <td>touch screen stylus pen</td>
              </tr>
              <tr>
                <td>Memory slot</td>
                <td>1</td>
                <td>1</td>
                <td>1</td>
              </tr>
              <tr>
                <td>RAM</td>
                <td>8GB</td>
                <td>8GB</td>
                <td>8GB</td>
              </tr>
            </table>
          </div>
        </Container>
      </section>
      <section>
        <Container>
          <h2 className="head-txt-1 text-start">
            <span>Detailed</span> Overview
          </h2>
          <p style={{ textIndent: "40px" }} className="over-para">
            The Samsung Galaxy A15 5G boasts a sleek and modern design,
            featuring a durable plastic frame and back. The device has a
            comfortable in-hand feel with rounded edges and a matte finish that
            resists fingerprints. It’s available in several color options,
            including black, white, and blue, giving users some flexibility in
            style.
          </p>
          <div>
            <table className="details-table">
              <tr>
                <th>Display</th>
                <td>6.5-inch Infinity-V display with a Full HD+ resolution</td>
              </tr>
              <tr>
                <th>Performance</th>
                <td>MediaTek Dimensity 700 chipset</td>
              </tr>
              <tr>
                <th>Camera System</th>
                <td>
                  Main Camera: 50MP Ultra-Wide Camera: 5MP Depth Sensor: 2MP
                </td>
              </tr>
              <tr>
                <th>Battery Life</th>
                <td>5,000mAh battery</td>
              </tr>
              <tr>
                <th>Connectivity and 5G</th>
                <td>
                  Wi-Fi 802.11ac, Bluetooth 5.1, NFC, and a USB Type-C port
                </td>
              </tr>
              <tr>
                <th>Software and Features</th>
                <td>UI 5.0 based on Android 13</td>
              </tr>
            </table>
          </div>
          <div>
            <h2 className="head-txt-1 text-start">
              <span>Customer</span> Review
            </h2>
            <div className="row">
              <div className="col-lg-7">
                <div>
                  <table className="table-reivew">
                    <tr>
                      <td>5 Star</td>
                      <td>
                        <ProgressBar now={60} />
                      </td>
                    </tr>
                    <tr>
                      <td>4 Star</td>
                      <td>
                        <ProgressBar now={60} />
                      </td>
                    </tr>
                    <tr>
                      <td>3 Star</td>
                      <td>
                        <ProgressBar now={60} />
                      </td>
                    </tr>
                    <tr>
                      <td>2 Star</td>
                      <td>
                        <ProgressBar now={60} />
                      </td>
                    </tr>
                    <tr>
                      <td>1 Star</td>
                      <td>
                        <ProgressBar now={60} />
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
              <div className="col-lg-5 d-flex justify-content-start align-items-center">
                <div>
                  <div>
                    <Rate disabled defaultValue={2} className="rating-star" />
                    4.0
                    <p className="revieew">1550 Rating & 300 Reviews </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
      <section className="py-4">
        <Container>
          <h2 className="head-txt-1 text-start">
            <span>Top</span> Reviews
          </h2>
          <div className="row">
            <div className="slider-container">
              <Slider {...settings}>
                <div className="px-3">
                  <div className="review-slide">
                    <p>John k</p>
                    <Rate
                      disabled
                      defaultValue={2}
                      style={{ fontSize: "12px" }}
                    />
                    <p>
                      The camera quality is phenomenal, especially in low light,
                      and the performance is lightning-fast.
                    </p>
                  </div>
                </div>
                <div className="px-3">
                  <div className="review-slide">
                    <p>John k</p>
                    <Rate
                      disabled
                      defaultValue={2}
                      style={{ fontSize: "12px" }}
                    />
                    <p>
                      The camera quality is phenomenal, especially in low light,
                      and the performance is lightning-fast.
                    </p>
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </Container>
      </section>
      </div>
      <FAQ/>
      <RecentSearch/>
    </>
  );
};

export default TabsDesc;
